/* app/js/src/components/user/common/user-form/user-action-permissions/user-action-permissions.component.scss */
.action-permissions {
  width: 30%;
  text-align: left;
  color: #879baf;
  margin-top: 5%;
  margin-left: 5%;
  font-weight: bold;
}
.action-permissions tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.action-permissions td {
  padding-top: 10px;
  padding-bottom: 10px;
}
.action-permissions td span {
  cursor: pointer;
}
/*# sourceMappingURL=user-action-permissions.component.css.map */
